import React from 'react'

export const PaymentPolicy = () => {
  return (
    <section className="border-top py-5">
      <div className="container">
        <h6>Return, shipping and refund policy</h6>
        <p>
          <span className="fw-bold ">Returns</span> - You have 30 (change this) calendar days to return an item from the
          date you received it. To be eligible for a return, your item must be unused and in the same condition that you
          received it. Your item must be in the original packaging. Your item needs to have the receipt or proof of
          purchase.
        </p>
        <p>
          <span className="fw-bold">Refunds</span> - Once we receive your item, we will inspect it and notify you that
          we have received your returned item. We will immediately notify you on the status of your refund after
          inspecting the item. If your return is approved, we will initiate a refund to your credit card (or original
          method of payment). You will receive the credit within a certain amount of days, depending on your card
          issuer&apos;s policies
        </p>

        <p>
          <span className="fw-bold">Shipping</span> - You will be responsible for paying for your own shipping costs for
          returning your item. Shipping costs are nonrefundable. If you receive a refund, the cost of return shipping
          will be deducted from your refund.
        </p>
      </div>
    </section>
  )
}
